<div class="progress-indicator">
  <atom-label *ngIf="progressResult" [text]="progressResult" class="progress-indicator__title" />

  <div class="progress-indicator__info" [ngClass]="{'progress-indicator__info--title': progressTitle }" >
    <atom-label *ngIf="progressTitle" [text]="progressTitle" class="progress-indicator__info__subtitle"/>
    <atom-label [text]="progressPercentage+'%'"  class="progress-indicator__info__percentage" [tooltipText]="progressTooltip" />
  </div>
  <atom-progress-bar [progressValue]="progressPercentage"  [tooltipText]="progressTooltip" />
</div>
